import * as React from "react";
import "./AddCampusDlg.scss";
import { Country } from "@testout/testout-commerce/models/Country";
import Dialog from "./input/Dialog";
import TextCtl from "./input/TextCtl";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import LabelCtl from "./input/LabelCtl";
import SelectCtl from "./input/SelectCtl";
import PostalAddressCtl from "./PostalAddressCtl";
import { PostalAddress } from "@testout/testout-commerce/models/commerce/PostalAddress";
import Api from "./Api";
import { Campus } from "@testout/testout-commerce/models/labsim/Campus";

interface AddCampusProps {
    defaultName?: string;
    defaultPostal?: PostalAddress;
    isOpen: boolean;
    onClose: (value?: string) => void;
}

interface AddCampusState {
    disabled: boolean;
    campusName?: string;
    campusDisplayStyle?: string;
    campusPostal?: PostalAddress;
    error?: string;
}

export default class AddCampusDlg extends React.PureComponent<AddCampusProps, AddCampusState> {
    constructor(props: AddCampusProps) {
        super(props);
        let postal = new PostalAddress(this.props.defaultPostal || { countryCode: "USA" })
        if (postal.countryCode)
            postal.countryCode = Country.byCode.find(c => c.iso2 === postal.countryCode || c.name === postal.countryCode || c.countryCode === postal.countryCode)?.countryCode ?? Country.defaultCode;
        else
            postal.countryCode = Country.defaultCode;
        this.state = {
            disabled: false,
            campusName: this.props.defaultName ?? "",
            campusDisplayStyle: "School",
            campusPostal: postal
        };
    }

    private _displayStyle: ListItem[] = [
        { name: "School", value: "SCHOOL" },
        { name: "Campus", value: "CAMPUS" },
        { name: "Company", value: "COMPANY" }
    ];

    componentDidUpdate(props: AddCampusProps) {
        if (!props.isOpen && this.props.isOpen) {
            let postal = new PostalAddress(this.props.defaultPostal || { countryCode: "USA" })
            if (postal.countryCode)
                postal.countryCode = Country.byCode.find(c => c.iso2 === postal.countryCode || c.name === postal.countryCode || c.countryCode === postal.countryCode)?.countryCode ?? Country.defaultCode;
            else
                postal.countryCode = Country.defaultCode;
            this.setState({ campusName: this.props.defaultName ?? "", campusPostal: postal });
        }
    }

    onNameChange = (value: string) => {
        this.setState({ campusName: value });
    }

    onDisplayStyleChange = (value: string) => {
        this.setState({ campusDisplayStyle: value });
    }

    onPostalChange = (postal: PostalAddress) => {
        this.setState({ campusPostal: postal });
    }

    onCreateClick = () => {
        this.setState({ disabled: true }, async () => {

            try {
                const result = await Api.post<Campus>("/api/campuses",
                    {
                        campusName: this.state.campusName ?? "",
                        address: this.state.campusPostal?.line1,
                        city: this.state.campusPostal?.city,
                        region: this.state.campusPostal?.stateOrProvince,
                        postalCode: this.state.campusPostal?.postalCode,
                        country: this.state.campusPostal?.countryCode,
                        campusDisplayStyle: this.state.campusDisplayStyle ?? "SCHOOL",
                    });
                this.props.onClose(result.campusId);
            } catch (error: any) {
                this.setState({ disabled: false, error: error.message });
            }
        });
    }

    onCancel = () => {
        this.props.onClose(undefined);
    }

    render() {
        return <Dialog title="Create CertMaster Institution" className="AddCampusDlg" isOpen={this.props.isOpen} disableClose={this.state.disabled} onClose={this.onCancel}>
            <LabelCtl label="Name">
                <TextCtl placeholder="name" disabled={this.state.disabled} value={this.state.campusName} onChange={this.onNameChange} />
            </LabelCtl>
            <LabelCtl label="Display Style">
                <SelectCtl value={this.state.campusDisplayStyle} items={this._displayStyle} hideItemValue={true} onChange={this.onDisplayStyleChange} />
            </LabelCtl>
            <LabelCtl label="Address" useDiv={true}>
                <PostalAddressCtl disabled={this.state.disabled} postal={this.state.campusPostal ?? new PostalAddress({ countryCode: "USA" })}
                    onChange={this.onPostalChange} defaultCountryCode="USA" hideExtraLines={true} />
            </LabelCtl>
            {this.state.error && <div>{this.state.error}</div>}
            <footer>
                <button className="primary" disabled={this.state.disabled} onClick={this.onCreateClick}>Create Institution</button>
                <button className="secondary" disabled={this.state.disabled} onClick={this.onCancel}>Cancel</button>
            </footer>
        </Dialog>;
    }
}